const AgeRangeYearIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z" />
      <path d="M9.5 9.5h1.5v7H9.5z" />
      <path d="M14.5 9.5h1.5v7h-1.5z" />
    </svg>
  );
};

export default AgeRangeYearIcon;
